import React from 'react';
import PropTypes from 'prop-types';
import {Form, Formik} from 'formik';
import {shallowEqual, useSelector} from 'react-redux';
import * as Yup from 'yup';
import FieldInput from '../FieldInput';
import FieldSelect from '../FieldSelect';
import {errors as E} from 'common/constants/errors';
import {floorOptions, lotPropertyFloorOptions} from '../../constants/options';
import {propertyTypesGroups as PT} from '../../../modules/Inspection/constants/propertyTypesGroups';
import styles from './styles.module.scss';

const FreeTextAndIDSchema = Yup.object().shape({
  freeText: Yup.string()
    .required(E.REQUIRED_FIELD),
  freeID: Yup.object()
    .shape({value: Yup.number()})
    .required(E.REQUIRED_FIELD),
});

const FormPreview = ({
                       pdf,
                       imageSrc,
                       formInitialValues,
                       onConfirm,
                       onReject,
                     }) => {
  const propertyTypeID = useSelector(state => state.shumaProperties.propertyTypeID, shallowEqual);
  const isGroundOrLot = PT.GROUND_OR_LOT.includes(propertyTypeID);

  const getInitialFloorID = freeID => {
    const [floorOption] =
      (isGroundOrLot ? lotPropertyFloorOptions : floorOptions)
        .filter(option => option.value === freeID);

    return floorOption || null;
  };

  const {freeText, freeID} = formInitialValues;
  const initialValues = {
    freeText: freeText || '',
    freeID: isGroundOrLot
      ? getInitialFloorID(freeID) || lotPropertyFloorOptions[7]
      : getInitialFloorID(freeID) || floorOptions[6]
  };

  const handleSubmit = (values) => {
    if (onConfirm) {
      const {freeText, freeID: {value: freeID}} = values;
      onConfirm({freeText, freeID});
    }
  };

  return (
    <div className={styles.previewContainer}>
      <div>{pdf}</div>
      <div className={styles.modalApiImage}>
        {imageSrc && <img src={imageSrc} alt="img" className={styles.image}/>}
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        validationSchema={FreeTextAndIDSchema}
        enableReinitialize={true}
      >
        {({values}) => (
          <Form>
            <div className={styles.formContainer}>
              <div className={styles.fieldsContainer}>
                <div className={styles.firstInput}>
                  <FieldInput
                    fieldId="freeText"
                    type={'text'}
                    value={values.freeText}
                    label={(
                      <div>
                        <span className={styles.mandatoryMark}>*</span>
                        כותרת לתמונה
                      </div>
                    )}
                  />
                </div>
                <div className={styles.lastInput}>
                  <FieldSelect
                    fieldId="freeID"
                    type={'text'}
                    value={values.freeID}
                    label={(
                      <div>
                        <span className={styles.mandatoryMark}>*</span>
                        קומה
                      </div>
                    )}
                    options={isGroundOrLot ? lotPropertyFloorOptions : floorOptions}
                    menuPosition={'fixed'}
                    hideResetOption={true}
                  />
                </div>
              </div>
            </div>
            <div className={styles.modalButtons}>
              <button
                type="button"
                className={styles.buttonCancel}
                onClick={onReject}
              >
                <span>ביטול</span>
              </button>
              <button
                type="submit"
                className={styles.buttonSubmit}
              >
                <span>אשר והוסף לשומה</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

FormPreview.propTypes = {
  imageSrc: PropTypes.string,
  formInitialValues: PropTypes.object,
  onConfirm: PropTypes.func,
  onReject: PropTypes.func,
};

export default FormPreview;
